/**
 * Validate if a string is a valid URL format with HTTP/HTTPS protocol
 *
 * @param str - The string to validate
 * @returns true if the string is a valid HTTP/HTTPS URL, false otherwise
 *
 * @example
 * isValidUrl('https://example.com') // true
 * isValidUrl('http://example.com/path') // true
 * isValidUrl('ftp://example.com') // false (not HTTP/HTTPS)
 * isValidUrl('not a url') // false
 * isValidUrl('') // false
 */
export function isValidUrl(str: string): boolean {
  if (!str || str.trim() === '') return false

  try {
    const url = new URL(str.trim())
    // Require http or https protocol
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
}
